export var SocialAlignment = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};